<script lang="ts" context="module">
  let instances: HTMLElement[] = [];

  function getMenuToggles(): HTMLElement[] {
    return instances;
  }

  export {getMenuToggles};
</script>

<script lang="ts">
  import {onMount, onDestroy} from 'svelte';

  import {getModifierClassName} from '$lib/utils/components';

  import {Icon, IconId} from '$lib/components/icon';

  import {MenuState} from './enums';
  import type {MenuToggleModifier} from './enums';

  export let modifiers: MenuToggleModifier[] = [];
  export let state: MenuState = MenuState.Closed;
  let klass = '';
  export {klass as class};

  $: iconId = state === MenuState.Closed ? IconId.Burger : IconId.Cross;

  let baseClassName = 'menu-toggle';
  let toggleEl: HTMLButtonElement;

  $: modifiersClassName = getModifierClassName(baseClassName, modifiers);
  $: className = [baseClassName, klass, modifiersClassName]
    .filter(Boolean)
    .join(' ');

  onMount(() => {
    instances = [...instances, toggleEl];
  });

  onDestroy(() => {
    instances = instances.filter((instance) => instance !== toggleEl);
  });
</script>

<button bind:this={toggleEl} class={className} on:click>
  <Icon class="u-display--block" id={iconId} />
</button>
